var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#github_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.669 0C4.24 0 .662 3.606.662 8.066a8.06 8.06 0 0 0 5.475 7.652c.398.08.543-.173.543-.387 0-.187-.013-.828-.013-1.496-2.227.481-2.69-.961-2.69-.961-.359-.935-.89-1.175-.89-1.175-.728-.494.054-.494.054-.494.809.053 1.233.828 1.233.828.716 1.228 1.869.881 2.333.667.066-.52.278-.881.504-1.081-1.777-.187-3.646-.882-3.646-3.98 0-.881.318-1.603.822-2.163-.08-.2-.358-1.029.08-2.137 0 0 .676-.214 2.2.828A7.697 7.697 0 0 1 8.669 3.9a7.7 7.7 0 0 1 2.001.267c1.525-1.042 2.2-.828 2.2-.828.438 1.108.16 1.936.08 2.137.517.56.822 1.282.822 2.163 0 3.098-1.869 3.78-3.658 3.98.291.253.543.734.543 1.495 0 1.082-.013 1.95-.013 2.217 0 .214.146.468.543.388a8.06 8.06 0 0 0 5.475-7.653C16.675 3.606 13.082 0 8.67 0Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "github_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.662 0h16v16h-16z"
  })))));
};
export default SvgGithub;